import React from 'react';
import { getProductsPaginated } from '../../api/productapi';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SearchBar from '../SearchBar';
import { updateRedirect } from './../../helpers/redirect';
import '../css/View.css';
import { formatDateFields } from '../../helpers';

import DataTableBase from '../utils/DataTable';

class ProductView extends React.Component {
    constructor(props) {
        super(props);
        let filterValue = '';
        if (this.props.route.location.state) {
            filterValue = this.props.route.location.state.productFilter;
            if (this.props.route.location.state.from == 'branches') {
                this.props.route.history.push('/secure/branches');
                this.props.route.history.push(this.props.route.match.url);
            }
        }

        this.state = {
            data: [],
            products: [],
            expanded: {},
            product: {},
            loading: true,
            onlyActive: false,
            customFilters: {
                showOnlyActiveFilter: true,
                onlyActiveFilterLabel: "Only show active products",
                onlyActiveOnChange: this.onlyActiveOnChange
            },
            value: filterValue,
            edit: false,
            searches: false,
            create: false,

            totalRows: 0,
            perPage: 10,
            orderBy: '',
            descending: false,
            defaultPage: 1
        }
        this.isSorting = false;
        this.onlyActiveOnChange = this.onlyActiveOnChange.bind(this);
        this.filterSearch = this.filterSearch.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
        this.handleCreate = this.handleCreate.bind(this);
        this.fetchData = this.fetchData.bind(this);

        this.handlePerRowsChange = this.handlePerRowsChange.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
        this.handleSort = this.handleSort.bind(this);
    }


    componentDidMount() {
        this.setState({
            loading: true
        });
        this.fetchData('', 0, false);
    }

    handleEdit(product) {
        this.setState({
            edit: true,
            product: product
        })
    }

    onlyActiveOnChange = (e) => {
        let value = this.state.value;
        let isChecked = e.target.checked;

        if (isChecked) {
            this.fetchData(value, 0, isChecked);
            this.setState({
                onlyActive: isChecked,
                page: 0,
                loading: true,
                value: value
            })
        } else if (!isChecked) {
            this.fetchData(value, 0, isChecked);
            this.setState({
                onlyActive: isChecked,
                page: 0,
                loading: true,
                value: value
            })
        }
    }

    handleCreate() {
        this.setState({
            create: true
        })
    }

    handleRedirectBranch(branch) {
        let branchFilter = { branchId: branch.branchId }
        this.setState({
            branchFilter: branchFilter,
            redirectBranch: true
        })
    }

    filterSearch(event) {
        let value = event.target.value;
        let isChecked = this.state.onlyActive;
        if (event.key === 'Enter' && value) {
            this.fetchData(value, 0, isChecked);
            this.setState({
                page: 0,
                loading: true,
                value: value
            })
        } else if (!value) {
            this.fetchData(value, 0, isChecked);
            this.setState({
                page: 0,
                loading: true,
                value: value
            })
        }
    }

    fetchData(filterValue, page, isChecked) {
        let p = <p className="cursor closed" >
            <FontAwesomeIcon icon="bars" size="sm" color="#28A745" />
        </p>;
        if (typeof filterValue === 'object')
            filterValue = this.state.value;
        if (page === undefined) {
            page = this.state.defaultPage;
        }
        if (page !== 0)
            page = page - 1;
        if (isChecked === undefined)
            isChecked = this.state.onlyActive;
        this.setState({ loading: true, error: false });
        let orderBy = this.state.orderBy;
        let descending = this.state.descending;
        getProductsPaginated(filterValue, page, this.state.perPage, orderBy, descending, isChecked)
            .then((res) => {
                let moreOptions = [];
                for (let x = 0; x < res.data.data.results.length; x++) {
                    moreOptions.push(p)
                }
                this.setState({
                    page: res.data.data.currentPage,
                    data: res.data.data.results,
                    pages: res.data.data.pageCount,
                    moreOptions: moreOptions,
                    loading: false,
                    totalRows: res.data.data.rowCount
                })
            }).catch((err) => {
                let errorList = [];
                err.response.data.errors.map(function (e) { errorList.push(e.message) });

                this.setState({
                    data: [],
                    error: true,
                    loading: false,
                    errorMessage: errorList
                })
            });
    }

    handlePerRowsChange(newPerPage, page) {
        this.setState({ perPage: newPerPage }, () => {
            this.fetchData(this.state.value, page, this.state.isChecked);
        });
    }

    handlePageChange(page) {
        if (this.isSorting) return;
        this.fetchData(this.state.value, page, this.state.isChecked);
    }

    handleSort(column) {
        this.isSorting = true;
        this.setState({ descending: !this.state.descending, orderBy: column.sortField }, () => {
            this.fetchData(this.state.value);
            this.isSorting = false;
        });
    }

    isInvalid(e) {
        let input = e.target;
        if (input.value) { input.classList.remove("is-invalid"); }
        else { input.classList.add("is-invalid"); }
    }

    render() {

        if (this.state.edit) {
            return <Redirect
                to={{
                    pathname: `/secure/productEdit/${this.state.product.productId}`,
                    state: { product: this.state.product }
                }}
            />;
        }

        if (this.state.create) {
            return <Redirect
                to={{
                    pathname: `/secure/productCreate`,
                }}
            />;
        }

        if (this.state.redirectBranch) {
            this.props.currentNavigationConnect({
                isOpen: false,
                selected: "branches",
                selectedAdmin: ''
            });
            return <Redirect
                to={{
                    pathname: `/secure/branchEdit/${this.state.branchFilter.branchId}`,
                    state: { branchFilter: this.state.branchFilter, from: 'products' }
                }}
            />;
        }

        const columns = [
            {
                name:
                    <div style={{ textIndent: 10, textAlign: "left", width: 200 }} >
                        Branch <FontAwesomeIcon icon="sort" size="sm" />
                    </div>,
                width: '200px',
                selector: row => row.branchName,
                sortable: true,
                sortField: 'branchName',
                cell: row => <div onClick={() => this.handleEdit(row)}><p style={{ marginLeft: "10px", }} className="cursor">{row.branchName}</p></div>
            },
            {
                name:
                    <div style={{ textIndent: 5, textAlign: "left", width: 120 }} >
                        Product Level <FontAwesomeIcon icon="sort" size="sm" />
                    </div>,
                width: '120px',
                selector: row => row.name,
                sortable: true,
                sortField: 'name',
                cell: (row) => <div onClick={() => this.handleEdit(row)}><p style={{ marginLeft: "6px", }} className="cursor">{row.name}</p></div>
            },
            {
                name:
                    <div style={{ textIndent: 0, textAlign: "left", width: 80 }} >
                        Status <FontAwesomeIcon icon="sort" size="sm" />
                    </div>,
                width: '80px',
                selector: row => row.productStatus,
                sortable: true,
                sortField: 'productStatus',
                cell: (row) => <div onClick={() => this.handleEdit(row)}><p className="cursor">{row.productStatus}</p></div>
            },
            {
                name:
                    <div style={{ textIndent: 0, textAlign: "left", width: 150 }} >
                        Primary/Alt <FontAwesomeIcon icon="sort" size="sm" />
                    </div>,
                width: '150px',
                selector: row => row.isPrimaryProduct,
                sortable: true,
                sortField: 'isPrimaryProduct',
                cell: (row) => <div onClick={() => this.handleEdit(row)}><p className="cursor">{row.isPrimaryProduct ? "Primary" : "Alternate"}</p></div>
            },
            {
                name:
                    <div style={{ textIndent: 0, textAlign: "left", width: 180 }} >
                        Start/End <FontAwesomeIcon icon="sort" size="sm" />
                    </div>,
                width: '180px',
                selector: row => row.startDate,
                sortable: true,
                sortField: 'startDate',
                cell: (row) => <div onClick={() => this.handleEdit(row)}>
                    <p className="cursor" style={{ paddingLeft: !row.isPrimaryProduct && !row.startDate ? 67 : 0 }}>{!row.isPrimaryProduct ? ((row.startDate && row.endDate) ?
                        (formatDateFields(row.startDate) + ' - ' + formatDateFields(row.endDate)) :
                        (row.startDate) ? (formatDateFields(row.startDate) + ' - ') :
                            (row.endDate) ? ' - ' + (formatDateFields(row.endDate)) : '') : ''}
                    </p>
                </div >
            },
            {
                name:
                    <div style={{ textIndent: 0, textAlign: "left", width: 250 }} >
                        Display Name <FontAwesomeIcon icon="sort" size="sm" />
                    </div>,
                width: '250px',
                selector: row => row.displayName,
                sortable: true,
                sortField: 'displayName',
                cell: (row) => <div onClick={() => this.handleEdit(row)}><p className="cursor">{row.displayName}</p></div>
            }
        ]

        return (
            <div >

                <SearchBar
                    onKeyUp={this.filterSearch}
                    onClick={this.filterSearch}
                    onChange={this.filterSearch}
                    value={this.state.value}
                    customFilters={this.state.customFilters}
                />

                <DataTableBase
                    columns={columns}
                    isLoading={this.state.loading}
                    data={this.state.data}
                    paginationTotalRows={this.state.totalRows}
                    paginationPerPage={this.state.perPage}
                    paginationDefaultPage={this.state.defaultPage}
                    onChangeRowsPerPage={this.handlePerRowsChange}
                    onChangePage={this.handlePageChange}
                    onSort={this.handleSort}
                />

                <button onClick={() => this.handleCreate()} className="btn mt-4"> + PRODUCT</button>
            </div>
        );
    }
}

export default connect(
    state => {
        return {
            products: state.data.products
        }
    },
    dispatch => ({
        currentNavigationConnect: (response) => { dispatch(updateRedirect(response)) }
    }))
    (ProductView);